/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
var core_1 = require('@angular/core');
/**
 * Used to provide a {@link ControlValueAccessor} for form controls.
 *
 * See {@link DefaultValueAccessor} for how to implement one.
 * @experimental
 */
exports.NG_VALUE_ACCESSOR = 
/*@ts2dart_const*/ new core_1.OpaqueToken('NgValueAccessor');
//# sourceMappingURL=control_value_accessor.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/@angular/common/src/forms-deprecated/directives/control_value_accessor.js
 ** module id = 410
 ** module chunks = 0
 **/